import { createBrowserRouter } from 'react-router-dom';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Projects } from './pages/Projects';
import { ProjectDetail } from './pages/ProjectDetail';
import { Articles } from './pages/Articles';
import { ArticleDetail } from './pages/ArticleDetail';
import { NotFound } from './pages/NotFound';

const router = createBrowserRouter([
  { path: '/',                  element: <Home /> },
  { path: '/about',             element: <About /> },
  { path: '/contact',           element: <Contact /> },
  { path: '/projects',          element: <Projects /> },
  { path: '/projects/:slug',    element: <ProjectDetail /> },
  { path: '/articles',          element: <Articles /> },
  { path: '/articles/:slug',    element: <ArticleDetail /> },
  { path: '*',                  element: <NotFound /> },
]);

export default router;
